<template>
    <div>
        <b-table striped hover small
            sticky-header="70vh"
            :items=eventList
            :fields=fields
            :sort-compare="sortCompare"
            :sort-by = "sortBy"
             @row-clicked="onRowClick">
           
            <template #cell(time)="data">
                {{ data.item.eventTime | timeFilter }}
            </template>
            <template #cell(sender)="data">
                <EventAddress :data="data.item.eventSource"/>
            </template>
            <template #cell(event)="data">
               <div v-if="data.item.eventType=='TRAVELLER_MESSAGE'"><TravellerMsg :data="data.item.data"/></div>
               <div v-else>Unknown event type</div>
            </template>
            <template #cell(actions)="data">
                <div v-if="data.item.eventSource.type=='VEHICLE'"><VehicleBrief :label="data.item.eventSource.id" :showLabel=false :showGps=false :showIndividualCall=true /></div>
            </template>
        </b-table>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import events from '@/store/dispatching/events.js'
import TravellerMsg from '@/components/Dispatching/Events/TravellerMsg'
import EventAddress from '@/components/Dispatching/Events/EventAddress'
import VehicleBrief from '@/components/Realtime/VehicleBrief'

export default {
    name: "EventTable",
    components: { TravellerMsg, EventAddress, VehicleBrief },
    data: function() {
        return {
            fields: [ 
                { key:'time' , thStyle:"width: 14em", label: this.$t('event.time') },
                { key:'sender' , label: this.$t('event.sender')},
                { key:'event' , label: this.$t('event.event')},
                { key:'actions' , label: this.$t('event.actions')} ],
            sortBy: 'time'
        }
    },
    computed:
        mapState({
        eventTimes: state => state.events.eventTimes,
        eventList: state => state.events.events,
        eventsViewTime: state => state.events.eventsViewTime
    }),
    watch: {
        eventTimes: function( newEventTimes ) {
            if( newEventTimes.lastEventTime != undefined && 
                moment(newEventTimes.lastEventTime).isAfter(this.eventsViewTime) ) {
                this.updateEvents()
            }
        }

    },
    beforeCreate() {
        if( !this.$store.state.events ) {
            this.$store.registerModule("events" , events )
        }
    },
    mounted() {
        this.updateEvents()
    },
    methods: {
        updateEvents() {
            this.$store.dispatch('events/updateEvents')
            this.$store.commit('events/setEventsViewTime')
        },
        sortCompare(row1, row2 ) {
            let timeA = moment( row1.eventTime )
            let timeB = moment( row2.eventTime )
            if( timeA.isBefore(timeB) ) return 1
            if( timeA.isAfter(timeB) ) return -1
            return 0
        },
        onRowClick(event) {
            this.$emit( "eventSelected" , event ) 
            
        }
    },
    filters: {
        timeFilter(value) {
            return moment(String(value)).format("DD.MM.YYYY HH:mm")
        }
    }
}
</script>